module.exports = __webpack_public_path__ + "static/img/Chocolate.aa16aae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Chocolate.jpg
// module id = baz9
// module chunks = 0